import {
  NOTIFICATION_EVENT_TYPES,
  NOTIFICATION_TAB_PARAMETERS
} from '@/constants/notification-constants';

/*
 * Para onde cada notificação leva ao ser clicada. Compartilhado entre o painel
 * do sino e a tela de histórico — se as duas divergirem, o mesmo item leva a
 * lugares diferentes dependendo de onde o usuário clicou.
 */

const PRE_VENDA_TYPES = [
  NOTIFICATION_EVENT_TYPES.PRE_VENDA,
  NOTIFICATION_EVENT_TYPES.PRE_VENDA_UPPER,
  NOTIFICATION_EVENT_TYPES.PRE_VENDA_EXTERNA,
  NOTIFICATION_EVENT_TYPES.PRE_VENDA_CLIENTE,
  NOTIFICATION_EVENT_TYPES.PRE_VENDA_DOLSPAY
];

const TAB_MAP = {
  [NOTIFICATION_EVENT_TYPES.PRE_VENDA]: NOTIFICATION_TAB_PARAMETERS.INTERNAS,
  [NOTIFICATION_EVENT_TYPES.PRE_VENDA_UPPER]: NOTIFICATION_TAB_PARAMETERS.INTERNAS,
  [NOTIFICATION_EVENT_TYPES.PRE_VENDA_EXTERNA]: NOTIFICATION_TAB_PARAMETERS.EXTERNAS,
  [NOTIFICATION_EVENT_TYPES.PRE_VENDA_CLIENTE]: NOTIFICATION_TAB_PARAMETERS.CLIENTES,
  [NOTIFICATION_EVENT_TYPES.PRE_VENDA_DOLSPAY]: NOTIFICATION_TAB_PARAMETERS.DOLSPAY
};

export default {
  methods: {
    isPreVendaNotification(eventType) {
      return PRE_VENDA_TYPES.includes(eventType);
    },

    isDuimpNotification(eventType) {
      return eventType === NOTIFICATION_EVENT_TYPES.DUIMP_ATUALIZADO || eventType === NOTIFICATION_EVENT_TYPES.COBRANCA_DUIMP_PENDENTE;
    },

    isUrgentCommissionNotification(eventType) {
      return eventType === NOTIFICATION_EVENT_TYPES.COMISSAO_URGENTE;
    },

    /* Nem todo evento tem destino — receiver e ficha assinada só informam.
       O componente usa isso para não dar aparência de clicável ao que não é. */
    hasNotificationTarget(eventType) {
      return this.isPreVendaNotification(eventType) || this.isDuimpNotification(eventType) || this.isUrgentCommissionNotification(eventType);
    },

    getTabParameterForNotification(eventType) {
      return TAB_MAP[eventType] || NOTIFICATION_TAB_PARAMETERS.INTERNAS;
    },

    navigateToNotificationTarget(notification) {
      if (this.isPreVendaNotification(notification.eventType)) {
        const tab = this.getTabParameterForNotification(notification.eventType);

        this.$router.push({ name: 'PreSaleReport', query: { tab } }).catch(() => {});

        return;
      }

      if (this.isDuimpNotification(notification.eventType)) {
        this.openDuimpManagement(notification);

        return;
      }

      if (this.isUrgentCommissionNotification(notification.eventType)) this.$router.push('/operations/commissions').catch(() => {});
    },

    openDuimpManagement(notification) {
      const metadata = notification.metadata || notification.data || {};
      const operationId = metadata.operationId;
      const operationCreatedAt = metadata.operationCreatedAt;
      const query = {};

      if (operationCreatedAt) {
        const dateOnly = new Date(operationCreatedAt).toISOString().substring(0, 10);
        query.startDate = dateOnly;
        query.endDate = dateOnly;
      }

      if (operationId) query.search = String(operationId);

      const route = this.$router.resolve({ name: 'DuimpDueOperationReport', query });

      window.open(route.href, '_blank');
    }
  }
};
